import RegistryPhaseWorkspace, {
  type RegistryPhaseWorkspaceConfig,
} from '../../../components/registry/RegistryPhaseWorkspace';
import { HEPATO_PHASES, computePhaseStatuses, type HepatoPhase } from './phases';
import Faza1Page from './Faza1Page';
import Faza2Page from './Faza2Page';
import Faza3Page from './Faza3Page';
import Faza4Page from './Faza4Page';

const config: RegistryPhaseWorkspaceConfig = {
  program: 'HEPATO',
  routeSegment: 'hepato',
  phases: HEPATO_PHASES,
  computeStatuses: computePhaseStatuses,
  pages: { 1: Faza1Page, 2: Faza2Page, 3: Faza3Page, 4: Faza4Page },
  emptyTitle: 'Registru hepato',
  emptyDescription: 'Pacientul nu are încă date de registru hepato importate.',
};

/**
 * Spațiul de lucru hepato: datele de registru importate, organizate pe cele 4 faze
 * ale fluxului medical HEPASKIN (fiecare fază are propriul URL, /patients/:id/hepato/faza-N).
 */
export default function HepatoWorkspace({ phase }: { phase: HepatoPhase }) {
  return <RegistryPhaseWorkspace config={config} phase={phase} />;
}
